import React from 'react';
import { useMedia } from 'react-use';
import DetailGallery from '@/components/menus/DetailGallery';
import { IMenu } from '@/@types/generated/contentful';

type ComponentProps = {
  menu: IMenu;
};

const DetailGalleryContainer: React.FC<ComponentProps> = ({ menu }) => {
  const isSp = useMedia('(max-width:640px)');

  return <DetailGallery menu={menu} isSp={isSp} />;
};

export default DetailGalleryContainer;
